import api from '../api'

export const screenResource = {
  all () {
    return api().get('/GetScreens')
  },

  find (id) {
    return api().get(`/GetScreen/${id}`)
  },

  create (payload) {
    return api().post('/CreateScreen', payload)
  },

  destroy (id) {
    return api().post(`/DeleteScreen/${id}`)
  }
}
